import { CACC, type CateringAccess } from './cateringAccessTypes';

/** Reads the Catering permissions again (every visit, so a change applies without logging in again). */
export const loadCateringAccessRequest = () => ({ type: CACC.LOAD_REQUEST as typeof CACC.LOAD_REQUEST });

export const loadCateringAccessDone = (access: CateringAccess) => ({
  type: CACC.LOAD_DONE as typeof CACC.LOAD_DONE,
  payload: access,
});

export type CateringAccessAction =
  | ReturnType<typeof loadCateringAccessRequest>
  | ReturnType<typeof loadCateringAccessDone>;
